import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_SUBSCRIPTION: undefined,
    API: {
      GET_SUBSCRIPTION: apiResourceActionCreator('subscription')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.Subscription), authToken, actions.user.api.getSubscription)

export function* getSubscription() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
}

const configuration = {
  name: 'getSubscription',
  action: actions,
  sagas: getSubscription,
  reducers: {
    success: (state, action) => ({
      ...state,
      error: null,
      currentSubscription: action.payload.subscription,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: null,
      currentSubscription: {},
      isFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getSubscription.js